import React, { useEffect, useState } from 'react'

const MountedModal = ({ children, isVisible }) => {
  const [isDisplayed, setIsDisplayed] = useState(isVisible)
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    if (isVisible) {
      setIsDisplayed(isVisible)
      setIsMounted(isVisible)
    } else {
      setIsDisplayed(false)
    }
  }, [isVisible])

  return isMounted ? React.cloneElement(children, { isVisible: isDisplayed, afterClose: () => setIsMounted(false) }) : null
}

export default MountedModal
